import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';

import Box from '@zenbusiness/zui/Box';

import { FIELD_NAMES } from '#client/components/BusinessInfoFieldset';
import { buildFieldName } from '#client/utils/form';

function SummaryView({ sectionKey }) {
  const { watch } = useFormContext();

  // Watch form fields to display in the complete state
  const businessName = watch(buildFieldName(FIELD_NAMES.NAME, sectionKey));
  const companyIndicator = watch(buildFieldName(FIELD_NAMES.INDICATOR, sectionKey));

  const fullBusinessName = companyIndicator ? `${businessName}, ${companyIndicator}` : businessName;

  return <Box component="span">{fullBusinessName}</Box>;
}

SummaryView.propTypes = {
  sectionKey: PropTypes.string.isRequired
};

export default SummaryView;
